var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 4.49996C10.5266 4.49996 12.78 5.91996 13.88 8.16663C12.78 10.4133 10.5266 11.8333 7.99996 11.8333C5.47329 11.8333 3.21996 10.4133 2.11996 8.16663C3.21996 5.91996 5.47329 4.49996 7.99996 4.49996ZM7.99996 3.16663C4.66663 3.16663 1.81996 5.23996 0.666626 8.16663C1.81996 11.0933 4.66663 13.1666 7.99996 13.1666C11.3333 13.1666 14.18 11.0933 15.3333 8.16663C14.18 5.23996 11.3333 3.16663 7.99996 3.16663ZM7.99996 6.49996C8.91996 6.49996 9.66663 7.24663 9.66663 8.16663C9.66663 9.08663 8.91996 9.83329 7.99996 9.83329C7.07996 9.83329 6.33329 9.08663 6.33329 8.16663C6.33329 7.24663 7.07996 6.49996 7.99996 6.49996ZM7.99996 5.16663C6.34663 5.16663 4.99996 6.51329 4.99996 8.16663C4.99996 9.81996 6.34663 11.1666 7.99996 11.1666C9.65329 11.1666 11 9.81996 11 8.16663C11 6.51329 9.65329 5.16663 7.99996 5.16663Z",
    fill: "black",
    fillOpacity: 0.55
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.3a92eceb.svg";
export { ForwardRef as ReactComponent };